import { Buffer } from 'buffer';

export interface SessionVoto {
  cpfCnpjLdap: string;
  idItemPauta: number;
  idPauta: number;
}

const PAUTA_UTILS_SESSION_VOTOS: string = Buffer.from(
  'PAUTA_UTILS_SESSION_VOTOS',
  'ascii'
).toString('base64');

const toEncrypt = (value: SessionVoto[]): string => {
  const buff: Buffer = Buffer.from(JSON.stringify(value), 'ascii');
  return buff.toString('base64');
};

const toDecrypt = (value: string): SessionVoto[] => {
  const buff: Buffer = Buffer.from(value, 'base64');
  return JSON.parse(buff.toString('ascii'));
};

export const pautaUtilsClear = () => {
  window.sessionStorage.setItem(PAUTA_UTILS_SESSION_VOTOS, toEncrypt([]));
};

const initializeSession = () => {
  if (!window.sessionStorage.getItem(PAUTA_UTILS_SESSION_VOTOS)) {
    pautaUtilsClear();
  }
};

export const pautaUtilsGetVotos = (): SessionVoto[] => {
  initializeSession();
  return toDecrypt(
    window.sessionStorage.getItem(PAUTA_UTILS_SESSION_VOTOS) as string
  ) as SessionVoto[];
};

export const pautaUtilsGetVotoByIdPauta = (
  cpfCnpjLdap: string,
  idPauta: number
): SessionVoto | null => {
  return (
    pautaUtilsGetVotos().find(
      (it) => it.idPauta === idPauta && it.cpfCnpjLdap === cpfCnpjLdap
    ) || null
  );
};

export const pautaUtilsSetVoto = (
  cpfCnpjLdap: string,
  idItemPauta: number,
  idPauta: number
) => {
  initializeSession();
  let votos: SessionVoto[] = [...pautaUtilsGetVotos()];
  if (!!pautaUtilsGetVotoByIdPauta(cpfCnpjLdap, idPauta)) {
    window.sessionStorage.setItem(
      PAUTA_UTILS_SESSION_VOTOS,
      toEncrypt(
        votos.map((it) => {
          return it.idPauta === idPauta && it.cpfCnpjLdap === cpfCnpjLdap
            ? {
                ...it,
                idItemPauta,
              }
            : it;
        })
      )
    );
  } else {
    votos.push({
      cpfCnpjLdap,
      idItemPauta,
      idPauta,
    });
    window.sessionStorage.setItem(PAUTA_UTILS_SESSION_VOTOS, toEncrypt(votos));
  }
};

export const getPautaComNovosVotos = (
  pauta: any,
  contasDisponiveis: any,
  data: any,
  idEvento: number
) => {
  pauta.votos = contasDisponiveis.map((conta: any) => {
    return {
      idItemPauta: data.idItemPauta,
      idPauta: data.idPauta,
      idEvento: idEvento,
      idConvocado: conta.idConvocado,
      tipo: conta.tipoPresenca,
      cpfRepresentante: data.cpf,
      data: data.dataVoto,
    };
  });

  return pauta;
};
